import { SystemFolderIds, UserRoles } from "./constants";
import { getUserRole } from "../user/user";

export const isSystemFolder = (id) => SystemFolderIds.includes(id);

export const isUserEditor = (roles) => {
  const userRoles = roles ? roles : getUserRole();
  if (!userRoles) {
    return false;
  }

  return (
    userRoles.includes(UserRoles.studyCenterEditor) ||
    userRoles.includes(UserRoles.StudyCenterEditorAdmin)
  );
};
